import React, { useEffect, useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import Icon from '../components/Icon'
import Reveal from '../components/Reveal'
import { TOOLS, ORDER_IMG, ORDER_PDF, ICN, GRAD, gradColor } from '../data/tools'

function ToolCard({ id }) {
  const navigate = useNavigate()
  const t = TOOLS[id]
  const bg = GRAD[id]
  return (
    <div className="card" onClick={() => navigate('/tool/' + id)} style={{ '--card-grad': bg }}>
      {/* {t.badge && <span className="badge-new">{t.badge}</span>} */}
      <span className="ico" style={{ background: bg }}>
        <Icon name={ICN[id]} size={22} stroke={2} />
      </span>
      <span className="go">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
          <path
            d="M5 12h14M13 6l6 6-6 6"
            stroke={gradColor(id)}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </span>
      <h4>{t.name}</h4>
      <p>{t.desc}</p>
    </div>
  )
}

function Mock1() {
  return (
    <div className="mock">
      <div className="mock-bar">
        <i className="mdr" /><i className="mdy" /><i className="mdg" />
      </div>
      <div className="mock-body">
        <div className="m-search"><Icon name="search" size={12} style={{ color: '#9AA3B1' }} /><span className="sk" /></div>
        <div className="m-grid">
          {['img', 'pdf', 'img', 'pdf', 'img', 'pdf'].map((k, i) => (
            <div className="m-tile" key={i}>
              <span className="m-chip" style={{ background: k === 'img' ? 'var(--img-tint)' : 'var(--pdf-tint)' }} />
              <span className="sk" />
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
function Mock2() {
  return (
    <div className="mock">
      <div className="mock-bar"><i className="mdr" /><i className="mdy" /><i className="mdg" /></div>
      <div className="mock-body">
        <div className="m-drop"><Icon name="upload" size={20} /><span className="sk" /></div>
        <div className="m-file">
          <span className="m-thumb" />
          <div className="col"><span className="sk a" /><span className="sk b" /><div className="m-prog"><i /></div></div>
        </div>
      </div>
    </div>
  )
}
function Mock3() {
  return (
    <div className="mock">
      <div className="mock-bar"><i className="mdr" /><i className="mdy" /><i className="mdg" /></div>
      <div className="mock-body">
        <div className="m-check"><Icon name="check" size={20} /></div>
        <div className="m-stats">
          <div className="m-stat"><div className="v">2.4MB</div><div className="l">BEFORE</div></div>
          <div className="m-stat"><div className="v g">0.6MB</div><div className="l">AFTER</div></div>
          <div className="m-stat"><div className="v g">74%</div><div className="l">SAVED</div></div>
        </div>
        <div className="m-dl"><Icon name="download" size={12} />Download</div>
      </div>
    </div>
  )
}

function Home() {
  const navigate = useNavigate()
  const location = useLocation()
  const [filter, setFilter] = useState('all')
  const [query, setQuery] = useState('')

  useEffect(() => {
    if (location.hash) {
      const el = document.getElementById(location.hash.slice(1))
      if (el) setTimeout(() => el.scrollIntoView({ behavior: 'smooth', block: 'start' }), 60)
    } else {
      window.scrollTo(0, 0)
    }
  }, [location])

  const q = query.trim().toLowerCase()
  const match = (id) => {
    const t = TOOLS[id]
    return !q || (t.name + ' ' + t.desc).toLowerCase().includes(q)
  }
  const imgList = ORDER_IMG.filter(match)
  const pdfList = ORDER_PDF.filter(match)

  const showImg = filter !== 'pdf' && imgList.length > 0
  const showPdf = filter !== 'img' && pdfList.length > 0

  return (
    <main className="view">
      {/* HERO */}
      <section className="hero">
        <div className="wrap">
          {/* <Reveal as="span" className="eyebrow">20+ image &amp; PDF tools, no sign-up</Reveal> */}
          <Reveal as="h1">
            Every file tool you need
            <br />
            <span className="accent">in one calm place.</span>
          </Reveal>
          <Reveal as="p" className="lead">
            Compress, convert, edit and organize your images and PDFs right in the browser. Free, fast, and private nothing to install.
          </Reveal>
          <Reveal className="search" role="search">
            <Icon name="search" size={20} />
            <input
              type="text"
              placeholder="Search a tool compress, merge, convert, remove background…"
              aria-label="Search tools"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
            />
            <button className="btn btn-primary" onClick={() => document.getElementById('tools')?.scrollIntoView({ behavior: 'smooth' })}>
              Search
            </button>
          </Reveal>
          <Reveal className="quick">
            <span className="lbl">Popular:</span>
            <button className="chip" onClick={() => navigate('/tool/compress')}><i className="i-img" />Compress Image</button>
            <button className="chip" onClick={() => navigate('/tool/merge')}><i className="i-pdf" />Merge PDF</button>
            <button className="chip" onClick={() => navigate('/tool/removebg')}><i className="i-img" />Remove Background</button>
            <button className="chip" onClick={() => navigate('/tool/pdf2word')}><i className="i-pdf" />PDF to Word</button>
            <button className="chip" onClick={() => navigate('/tool/img2pdf')}><i className="i-img" />Image to PDF</button>
          </Reveal>
          {/* <Reveal className="trust">
            <span><Icon name="check" size={16} style={{ color: '#16A34A' }} />100% free, no watermarks</span>
            <span><Icon name="check" size={16} style={{ color: '#16A34A' }} />Works on any device</span>
            <span><Icon name="check" size={16} style={{ color: '#16A34A' }} />Runs locally in your browser</span>
          </Reveal> */}
        </div>
      </section>

      {/* TOOLS */}
      <section className="tools" id="tools">
        <div className="wrap">
          <Reveal className="tools-head">
            <div>
              <h2>Pick a tool, get it done</h2>
              <p>Every tool runs in your browser and works straight away no account, no queue.</p>
            </div>
            <div className="tabs" role="tablist">
              {[
                { f: 'all', label: 'All tools', icon: null },
                { f: 'img', label: 'Image', icon: 'i-img' },
                { f: 'pdf', label: 'PDF', icon: 'i-pdf' },
              ].map((t) => (
                <button key={t.f} className={'tab' + (filter === t.f ? ' active' : '')} onClick={() => setFilter(t.f)}>
                  {t.icon && <i className={t.icon} />}
                  {t.label}
                </button>
              ))}
            </div>
          </Reveal>

          {showImg && (
            <div className="group" id="image">
              <Reveal className="group-label img">
                <span className="gico"><Icon name="images" size={20} /></span>
                <h3>Image tools</h3>
                <span className="count">{imgList.length} tools</span>
              </Reveal>
              <div className="grid">
                {imgList.map((id) => <ToolCard key={id} id={id} />)}
              </div>
            </div>
          )}

          {showPdf && (
            <div className="group" id="pdf">
              <Reveal className="group-label pdf">
                <span className="gico"><Icon name="file-text" size={20} /></span>
                <h3>PDF tools</h3>
                <span className="count">{pdfList.length} tools</span>
              </Reveal>
              <div className="grid">
                {pdfList.map((id) => <ToolCard key={id} id={id} />)}
              </div>
            </div>
          )}
        </div>
      </section>

      {/* HOW IT WORKS */}
      <section className="steps" id="how">
        <div className="wrap">
          <Reveal className="walk-head">
            <span className="eyebrow">How it works</span>
            <h2>From file to finished in three steps</h2>
            <p>No tutorials, no setup. Open a tool, drop your file, and download the result.</p>
          </Reveal>
          <div className="walk">
            {[
              { cls: 's1', n: 1, mock: <Mock1 />, h: 'Choose your tool', p: 'Browse or search the toolkit and open the image or PDF tool you need.' },
              { cls: 's2', n: 2, mock: <Mock2 />, h: 'Add your file', p: 'Drag and drop, or browse from your device. Multiple files are welcome too.' },
              { cls: 's3', n: 3, mock: <Mock3 />, h: 'Download the result', p: 'Your finished file is ready to save or share in seconds quality intact.' },
            ].map((s) => (
              <Reveal className="wstep" key={s.n}>
                <div className={'shot ' + s.cls}>
                  <span className="wbadge">{s.n}</span>
                  {s.mock}
                </div>
                <div className="wmeta"><h3>{s.h}</h3><p>{s.p}</p></div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* FEATURES */}
      <section className="features" id="why">
        <div className="wrap">
          <div className="why-band">
            <Reveal className="why-head">
              <span className="eyebrow">Why iLoveImgPdf</span>
              <h2>Everything you'd want, nothing you wouldn't</h2>
              <p>The small things that make iLoveImgPdf the easiest place to get a file job done.</p>
            </Reveal>
            <div className="zz">
              <svg className="zz-line" viewBox="0 0 1000 283" preserveAspectRatio="none">
                <polyline points="125,139 375,47 625,139 875,47" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" strokeDasharray="2 8" opacity=".85" />
              </svg>
              <div className="zz-row">
                <div className="zz-item c-indigo">
                  <div className="zz-node"><Icon name="shield-check" size={30} style={{ color: '#fff' }} /><span className="zz-badge circle"><Icon name="check" size={14} style={{ color: '#16A34A' }} /></span></div>
                  <h3>Private by design</h3>
                  <p>Files are processed right on your device never uploaded, never shared, never sold.</p>
                </div>
                <div className="zz-item c-amber">
                  <div className="zz-node"><Icon name="zap" size={30} style={{ color: '#fff' }} /><span className="zz-badge">~2s</span></div>
                  <h3>Fast, even big files</h3>
                  <p>Tuned to handle large images and PDFs in seconds, with no waiting room or daily limits.</p>
                </div>
                <div className="zz-item c-green">
                  <div className="zz-node"><Icon name="tag" size={30} style={{ color: '#fff' }} /><span className="zz-badge" style={{ color: '#16A34A' }}>FREE</span></div>
                  <h3>Free, no sign-up</h3>
                  <p>The full toolkit is open to everyone no account, no card, and no watermark on results.</p>
                </div>
                <div className="zz-item c-blue">
                  <div className="zz-node"><Icon name="monitor-smartphone" size={30} style={{ color: '#fff' }} /><span className="zz-badge circle"><Icon name="globe" size={15} style={{ color: '#2563EB' }} /></span></div>
                  <h3>Works everywhere</h3>
                  <p>Runs in any modern browser on phone, tablet or desktop nothing to download or install.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="cta">
        <div className="wrap">
          <Reveal className="cta-band">
            <h2>Get your files sorted in seconds</h2>
            <p>From a quick compress to a full PDF makeover the whole toolkit is one click away, completely free.</p>
            <a className="btn btn-white" onClick={() => document.getElementById('tools')?.scrollIntoView({ behavior: 'smooth' })}>
              Browse all tools
            </a>
          </Reveal>
        </div>
      </section>
    </main>
  )
}

export default Home
